import * as React from 'react'
import * as ReactDOM from 'react-dom'

const toastRoot = document.getElementById('toast-root')

export class ToastPortal extends React.Component {
	constructor(props: {}) {
		super(props)
		this.toastRootElement = document.createElement('div')
	}

	toastRootElement: HTMLDivElement

	componentDidMount(): void {
		if (toastRoot) {
			toastRoot.appendChild(this.toastRootElement)
		}
	}

	componentWillUnmount(): void {
		if (toastRoot) {
			toastRoot.removeChild(this.toastRootElement)
		}
	}

	render(): React.ReactNode {
		return ReactDOM.createPortal(
			this.props.children,
			this.toastRootElement,
		)
	}
}